import dsbridge from "./dsbridge";
import configUtil from "./config";
import PRDIDLIST, { NOT_LOGOUT_PRDIDS, PUSH_EXPLAIN_PRDIDS } from "./prdidList";
let toastTimeout;
function showToast(toastText) {
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
    let existingToast = document.getElementById("toast");
    document.body.removeChild(existingToast);
  }
  let toast = document.createElement("div");
  toast.id = "toast";
  toast.style.position = "fixed";
  toast.style.bottom = "20px";
  toast.style.left = "50%";
  toast.style.transform = "translateX(-50%)";
  toast.style.backgroundColor = "#666";
  toast.style.color = "#fff";
  toast.style.padding = "10px 20px";
  toast.style.borderRadius = "4px";
  toast.style.opacity = "0";
  toast.style.transition = "opacity 0.3s ease-in-out";
  toast.innerHTML = toastText;
  document.body.appendChild(toast);
  setTimeout(function () {
    toast.style.opacity = "1";
    toastTimeout = setTimeout(function () {
      toast.style.opacity = "0";
      setTimeout(function () {
        document.body.removeChild(toast);
        clearTimeout(toastTimeout);
        toastTimeout = null;
      }, 300);
    }, 2000);
  }, 100);
}
export default {
  getPublicPath(path) {
    return `${process.env.assetPrefix || ""}${path}`;
  },
  coinToMoney(coin) {
    return Math.floor(coin / 100) / 100;
  },
  pointToMoney(point, rate = 0) {
    return (point / rate).toFixed(2);
  },
  toast(text) {
    if (typeof window != "undefined" && window.dsBridge) {
      dsbridge.call("toast", { text });
    } else {
      showToast(text);
    }
  },
  isJsonObject(value) {
    return (
      typeof value == "object" &&
      Object.prototype.toString.call(value).toLowerCase() ==
        "[object object]" &&
      !value.length
    );
  },
  // 本地数据，永久记录
  getItem(key) {
    // let data=dsbridge.call('getItem', {key, value}) || value
    // if(!data){
    let data = localStorage.getItem(key);
    // }
    return data;
  },
  setItem(key, value) {
    value = this.isJsonObject(value) ? JSON.stringify(value) : value;
    localStorage.setItem(key, value);
    // dsbridge.call('setItem', {key, value});
  },
  removeItem(key) {
    dsbridge.call("removeItem", { key });
  },
  getPVersion() {
    return configUtil.getNativePhead().pversion;
  },
  getUrlParam(param_name) {
    const urlReg = new RegExp("(^|&)" + param_name + "=([^&]*)(&|$)");
    const result = window && window.location.search.substr(1).match(urlReg);
    if (result) {
      return unescape(result[2]);
    }
    return null;
  },
  getAppInfo(prdid = "211001") {
    var prd = null;
    for (var i = 0; i < PRDIDLIST.length; i++) {
      if (PRDIDLIST[i].prdid == prdid) {
        prd = prd || PRDIDLIST[i];
      }
    }
    return prd || PRDIDLIST[0];
    // return PRDIDLIST.filter(function (item) {
    //     return item.prdid == prdid;
    // })[0] || PRDIDLIST[0];
  },
  getAppName(prdid = "22000") {
    return this.getAppInfo(prdid).name;
  },
  inWechat() {
    return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
  },
  isIos() {
    let userAgent = navigator.userAgent;
    return userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iOS") > -1;
  },
  copyString(str) {
    var input = str;
    const el = document.createElement("textarea");
    el.value = input;
    el.setAttribute("readonly", "");
    el.style.contain = "strict";
    el.style.position = "absolute";
    el.style.left = "-9999px";
    el.style.fontSize = "12pt"; // Prevent zooming on iOS

    const selection = getSelection();
    var originalRange = false;
    if (selection.rangeCount > 0) {
      originalRange = selection.getRangeAt(0);
    }
    document.body.appendChild(el);
    el.select();
    el.selectionStart = 0;
    el.selectionEnd = input.length;

    var success = false;
    try {
      success = document.execCommand("copy");
    } catch (err) {
      console.error(err);
    }

    document.body.removeChild(el);

    if (originalRange) {
      selection.removeAllRanges();
      selection.addRange(originalRange);
    }

    return success;
  },
  formatDate(data, fmt) {
    const o = {
      // 'y+': data.getFullYear() + 1,                 // 月份
      "M+": data.getMonth() + 1, // 月份
      "d+": data.getDate(), // 日
      "h+": data.getHours(), // 小时
      "m+": data.getMinutes(), // 分
      "s+": data.getSeconds(), // 秒
      "q+": Math.floor((data.getMonth() + 3) / 3), // 季度
      S: data.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${data.getFullYear()}`.substr(4 - RegExp.$1.length)
      );
    }

    const selection = getSelection();
    var originalRange = false;
    if (selection.rangeCount > 0) {
      originalRange = selection.getRangeAt(0);
    }
    document.body.appendChild(el);
    el.select();
    el.selectionStart = 0;
    el.selectionEnd = input.length;

    var success = false;
    try {
      success = document.execCommand("copy");
    } catch (err) {
      console.error(err);
    }

    document.body.removeChild(el);

    if (originalRange) {
      selection.removeAllRanges();
      selection.addRange(originalRange);
    }

    return success;
  },
  disaEnabBodyScroll(isShow = false, needRestore = true) {
    if (isShow) {
      this.disableBodyScroll(needRestore);
    } else {
      this.enableBodyScroll(needRestore);
    }
  },
  disableBodyScroll(needRestore = false) {
    window.stTemp = Math.max(
      document.body.scrollTop,
      document.documentElement.scrollTop
    );
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    if (needRestore) {
      document.body.style.top = -window.stTemp + "px";
    }
  },
  enableBodyScroll(needRestore = false) {
    document.body.style.overflow = "scroll";
    document.body.style.position = "static";
    if (needRestore) {
      document.body.style.top = "0px";
      document.body.scrollTop = window.stTemp;
      document.documentElement.scrollTop = window.stTemp;
    }
  },
  formatDate(data, fmt) {
    const o = {
      // 'y+': data.getFullYear() + 1,                 // 月份
      "M+": data.getMonth() + 1, // 月份
      "d+": data.getDate(), // 日
      "h+": data.getHours(), // 小时
      "m+": data.getMinutes(), // 分
      "s+": data.getSeconds(), // 秒
      "q+": Math.floor((data.getMonth() + 3) / 3), // 季度
      S: data.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${data.getFullYear()}`.substr(4 - RegExp.$1.length)
      );
    }

    Object.keys(o).forEach((k) => {
      if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
        );
      }
    });

    return fmt;
  },
  // 绑定window事件，可绑定多次
  addWindowEvent(eventName, func) {
    var oldFun = window[eventName];
    if (typeof window[eventName] != "function") {
      window[eventName] = function () {
        func.apply(this, arguments);
      };
    } else {
      window[eventName] = function () {
        oldFun.apply(this, arguments);
        func.apply(this, arguments);
      };
    }
  },
  unique(arr, attr) {
    const res = new Map();
    return arr.filter((a) => !res.has(a[attr]) && res.set(a[attr], 1));
  },
  isEmptyOrNull(v) {
    // 判断字符串是否为空
    return typeof v === "undefined" || v === "" || v === null;
  },
  isClientSide() {
    return typeof window !== "undefined";
  },
  isServerSide() {
    return !this.isClientSide();
  },
  isNotLogoutByPrdId(prdId) {
    return NOT_LOGOUT_PRDIDS.includes(prdId);
  },
  isNotLogoutBySdkInfo(str) {
    //Default:登录注销 或者 InfoClear:清理信息
    return str === "InfoClear";
  },
  isPushExplainByPrdId(prdId) {
    return PUSH_EXPLAIN_PRDIDS.includes(prdId);
  },
};
